import { ICart, ICartProductDetail } from "../../types/cart";
import { ICouponCode } from "../../types/couponCode";
import { IGiftCard } from "../../types/giftCard";

import { cartTotal } from "./cart";

export const computeCartSubTotal = (items: ICartProductDetail[]): number => {
  return items.reduce(
    (acc: number, item: ICartProductDetail) =>
      acc + item.product.actualPrice * item.quantity,
    0
  );
};

export const computeCartTotal = (
  subTotal: number,
  coupon?: ICouponCode,
  giftCards?: IGiftCard[]
): number => {
  return cartTotal({ subTotal, coupon, giftCards } as ICart);
};
